import { createSlice } from '@reduxjs/toolkit'
import Cookies from 'js-cookie'
import itTranslations from '../translations/it.json'

const initialState = {
  language: Cookies.get('i18next_SMARTCAF_LANG') || 'it',
  translations: itTranslations,
}

export const selectTranslations = (state) => state.translation

const translationSlice = createSlice({
  name: 'translation',
  initialState,
  reducers: {
    setLanguage: (state, action) => {
      state.language = action.payload
    },
    setTranslations: (state, action) => {
      state.translations = action.payload
    },
  },
})

export const { setLanguage, setTranslations } = translationSlice.actions
export default translationSlice.reducer
